import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import React, { useContext, useState } from "react";
import backgroundProvider from "../../../assets/img/backgroundProvider.png";
import DatePicker from "../../../components/common/DatePicker";
import ShowImage from "../../../components/common/ShowImage";
import TextFieldOutlined from "../../../components/common/TextFieldOutlined";
import UserContext from "../../../context/user-context";
import useInputUserChange from "../../../hooks/useInputUserChange";
import useShowImage from "../../../hooks/useShowImage";
import useStateDate from "../../../hooks/useStateDate";
import { useTranslation } from "../../../hooks/useTranslation";
import useUploadImage from "../../../hooks/useUploadImage";
import { fileNames } from "../../../utils/imageUtil";
import { CompanionTabIndex, EntrantTabIndex } from "../../../utils/tabIndex";

const PersonalAccidents = () => {
  const getImage = useShowImage();
  const { state } = useContext(UserContext);
  const { t, BundleKey } = useTranslation();
  const { uploadNewPhoto } = useUploadImage();
  const [artPhoto1, setArtPhoto1] = useState<any>(getImage(state.artPhoto1));
  const [artPhoto2, setArtPhoto2] = useState<any>(getImage(state.artPhoto2));
  const { handleInputChange, handleDatePickerChange } = useInputUserChange();
  const { date, setDate } = useStateDate(state.artExpirationDate);

  const uploadNewArt1Photo = (newPhoto: any) => {
    setArtPhoto1(newPhoto);
    uploadNewPhoto(
      newPhoto,
      "artPhoto1",
      fileNames.ART_PHOTO_1_FILENAME,
      isFull()
    );
  };

  const uploadNewArt2Photo = (newPhoto: any) => {
    setArtPhoto2(newPhoto);
    uploadNewPhoto(
      newPhoto,
      "artPhoto2",
      fileNames.ART_PHOTO_2_FILENAME,
      isFull()
    );
  };

  const isFull = () => {
    return state.registrationType === "full";
  };

  return (
    <form noValidate>
      <Grid container direction="row" spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            {t(BundleKey.DETAIL_PROVIDER_ACCIDENTS_TITLE)}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextFieldOutlined
            value={state.artCompanyName}
            name="artCompanyName"
            type="text"
            label={t(BundleKey.DETAIL_PROVIDER_ACCIDENTS_COMPANY_PLACEHOLDER)}
            InputProps={{ tabIndex: EntrantTabIndex.hidden }}
            onChange={(value) => handleInputChange("artCompanyName", value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextFieldOutlined
            name="numberPolicy"
            value={state.artPolicyNumber}
            type="text"
            label={t(BundleKey.DETAIL_PROVIDER_ACCIDENTS_NUMBER_PLACEHOLDER)}
            InputProps={{ tabIndex: EntrantTabIndex.hidden }}
            onChange={(value) => handleInputChange("artPolicyNumber", value)}
          />
        </Grid>
        <Grid item xs={12}>
          <DatePicker
            id="artExpirationDate"
            name="artExpirationDate"
            value={date}
            label={t(BundleKey.DETAIL_PROVIDER_ACCIDENTS_DATE_PLACEHOLDER)}
            tabIndex={
              state.config?.companion
                ? CompanionTabIndex.dateOfDue
                : EntrantTabIndex.dateOfDue
            }
            size="medium"
            minDate={moment().add(1, "day").toDate()}
            minDateMessage={t(BundleKey.DETAIL_PROVIDER_ACCIDENTS_DATE_ERROR)}
            onchange={(date) => {
              setDate(date);
              handleDatePickerChange(
                "artExpirationDate",
                date,
                "isInvalidArtExpirationDate"
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ShowImage
            title={t(BundleKey.DETAIL_PROVIDER_ACCIDENTS_FIRSTPHOTO)}
            defaultImage={backgroundProvider}
            image={artPhoto1}
            uploadNewPhoto={uploadNewArt1Photo}
            alt="image photo accidents personal"
            circle={false}
            small
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ShowImage
            title={t(BundleKey.DETAIL_PROVIDER_ACCIDENTS_SECONDPHOTO)}
            defaultImage={backgroundProvider}
            image={artPhoto2}
            uploadNewPhoto={uploadNewArt2Photo}
            alt="image photo accidents personal"
            circle={false}
            small
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default PersonalAccidents;
